import React from "react";

import classes from "./Header.module.css";

const Footer = () => {
  return (
    <>
      <div className={classes.footer}>
        <a href="https://www.davidebalice.dev" target="_blank" rel="noreferrer">
          www.davidebalice.dev
        </a>
      </div>
    </>
  );
};

export default Footer;
